import React from 'react';
import { AdminProvider } from '@warehouse/quickbase';
import { useAdminScope } from '@warehouse/auth';
import { AdminQuickbase } from './Admin';
import Redirect from '../../components/library/Redirect';

export function Admin() {
	const { isAdmin, isLoading } = useAdminScope();

	if (isLoading) return null;
	if (!isAdmin) return <Redirect to="/titles" />;

	return (
		<AdminProvider>
			<AdminQuickbase />
		</AdminProvider>
	);
}
